import { useCollectionPin } from './useCollection';
import useHtmlHelpers from './useHtmlHelpers';
import { nextTick } from 'vue';

const imageCache = {};

const imageConstants = () => {
    const ImageFormat = {
        Raster: 'raster',
        SVG: 'svg',
    };
    Object.freeze(ImageFormat);

    return { ImageFormat };
};

const useImageCache = () => {
    const { ImageFormat } = imageConstants();
    const { getPinIconForCollectionType, getPinIconProps } = useCollectionPin();
    const { createHtmlElementFromComponent, rasterizeSvgElementAsImage } = useHtmlHelpers();

    const getIdForCollectionItemPin = (collectionType, pinOverlay, pinBackground, pinSize, imageType) => {
        return pinOverlay
            ? `${collectionType}-${pinOverlay}-${pinBackground}-${pinSize}-${imageType}`
            : `${collectionType}-${pinBackground}-${pinSize}-${imageType}`;
    };

    const getHtmlElementForCollectionItemPin = async (collectionType, pinOverlay, pinBackground, pinSize, imageFormat) => {
        try {
            const imageId = getIdForCollectionItemPin(collectionType, pinOverlay, pinBackground, pinSize, imageFormat);
            if (!imageCache[imageId]) {
                let element;
                const properties = getPinIconProps(pinOverlay, pinBackground, pinSize, imageFormat);
                const component = getPinIconForCollectionType(collectionType);
                const svgElement = createHtmlElementFromComponent(component, properties);
                await nextTick();

                switch (imageFormat) {
                    case ImageFormat.SVG:
                        element = svgElement;
                        break;
                    case ImageFormat.Raster:
                        element = rasterizeSvgElementAsImage(svgElement, pinSize);
                        break;
                    default:
                        throw new Error(`Unsupported pin format ${imageFormat}`);
                }

                element.id = imageId;
                imageCache[imageId] = element;
            }
            return imageCache[imageId];
        } catch (error) {
            console.error(`getHtmlElementForCollectionItemPin`, error);
        }
    };

    return {
        getHtmlElementForCollectionItemPin,
    };
};

export { useImageCache, imageConstants };
